import { NonServicePeriod, NonServicePeriodTypeEnum } from "src/app/types/non-service-period.type";
import { BuildServices } from "./generic-route-event.model";
import { DateTime } from "luxon";
import { _NonServicePeriod } from ".";

export class PreTripInspection extends _NonServicePeriod {

  public type = 'pre-trip';

  constructor(data: NonServicePeriod, services: BuildServices) {
    super(data, services);
    this.scheduledStart = DateTime.now();
    this.headerInfo.timeTo = this.scheduledStart?.toRelative();
    this.headerInfo.time = '';
    this.headerInfo.type = 'LABEL.preTrip';
    this.nonServicePeriods.nonServicePeriodType = NonServicePeriodTypeEnum.PreTrip;
    this.completed = data.hasBeenCompleted;
  }
}
